import { TypePolicies } from "@apollo/client";
import { enumTypePolicies, scalarTypePolicies } from "~generated/graphqlTypes";
import { infiniteScroll } from "./utils/infiniteScroll";

export const typePolicies: TypePolicies = {
  ...enumTypePolicies,
  ...scalarTypePolicies,
  Query: {
    fields: {
      checkoutConfigs: {
        ...infiniteScroll(),
      },
      homeowners: {
        ...infiniteScroll(),
      },
    },
  },
};
